import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import {
  LISTING_STATE_DRAFT,
} from '../../../../util/types';

// Import shared components
import { Button, H3, ListingLink } from '../../../../components';

// Import modules from this directory
import css from './HowItWorksPanel.module.css';
import IconCollection from '../../../../components/IconCollection/IconCollection';

const HowItWorksPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    onSubmit,
    submitButtonText,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const { state } = listing?.attributes || {};
  const isPublished = listing?.id && state !== LISTING_STATE_DRAFT;

  return (
    <div className={classes}>
      <H3 as="h1" className={css.title}>
        <IconCollection icon="howItWorksInfo" />
        {isPublished ? (
          <FormattedMessage
            id="EditListingDetailsPanel.title"
            values={{ listingTitle: <ListingLink listing={listing} />, lineBreak: <br /> }}
          />
        ) : (
          <FormattedMessage
            id="EditListingDetailsPanel.howItWorksListingTitle"
            values={{ lineBreak: <br /> }}
          />
        )}
      </H3>
      <div>
        <div className={css.container}>
          <p className={css.header}>
          At Travel Tribe, we connect travellers seeking authentic, personalized and  unique escapes with experienced local experts who craft individual,  unforgettable itineraries based on the travellers personal preferences. We believe in empowering travellers to discover the true essence and heart of a destination through the eyes of those who know it best.
          </p>

          <p className={css.paragraph}>
          By fostering meaningful connections and celebrating the richness of local cultures, supporting diversity, authentic experiences and adventures, we aim to create bespoke travel experiences for customers that inspire, enrich, and leave lasting memories of a lifetime.
          </p>

          <p className={css.paragraph}>
          To ensure we provide the most unique experiences to our travellers, we have  created a list of questions for you to ask yourself to see if you truly are a local expert!
          </p>
          <ul className={css.questionList}>
            <li>1. Have you been there yourself?</li>
            <li>2. Do you have detailed knowledge of local experiences and cultures?</li>
            <li>3. Do you understand the do’s and don’ts for a certain country or region (i.e. weather patterns, places to see or not to see, food recommendations, etc.)</li>
            <li>4. Do you know local businesses, tour advisors, community members (i.e. local guides and instructors, small businesses, accommodations, etc.) that support the local community and focus on sustainability, that the customer might find useful?</li>
          </ul>

          <p className={`${css.paragraph} ${css.highlight}`}>
          If the answer to all of these is ‘yes’, then we cannot wait for you to share your unique experiences with our travellers!
          </p>
        </div>
      </div>
      <Button
      className={css.submitButton}
      onClick={onSubmit}
      >
      {submitButtonText}
      </Button>
    </div>
  ); 
};  

export default HowItWorksPanel;